'use client';

import { CheckCircle2 } from 'lucide-react';

import { Button } from '@/components/ui/button';
import type { getPostHogSupportCopy } from '@/i18n/posthog-support-copy';

type SupportCopy = ReturnType<typeof getPostHogSupportCopy>;

export function PostHogSupportSent({
  copy,
  isSelecting,
  onViewRequest,
  subject,
}: {
  copy: SupportCopy;
  isSelecting: boolean;
  onViewRequest: () => void;
  subject: string;
}) {
  return (
    <div
      className="flex min-h-0 flex-1 items-center justify-center px-6 py-10"
      role="status"
    >
      <div className="max-w-sm text-center">
        <CheckCircle2 className="text-primary mx-auto size-9" aria-hidden />
        <h2
          className="mt-3 text-base font-semibold text-balance"
          data-support-view-heading
          tabIndex={-1}
        >
          {copy.requestReceived}
        </h2>
        <p className="text-muted-foreground mt-1 text-sm text-pretty">
          {copy.sent}
        </p>
        <p className="mt-3 text-sm text-pretty">
          <span className="text-muted-foreground">
            {copy.requestSubjectLabel}:{' '}
          </span>
          <span dir="auto" className="[overflow-wrap:anywhere]">
            {subject}
          </span>
        </p>
        <Button
          type="button"
          size="sm"
          variant="outline"
          className="mt-4 min-h-11 aria-disabled:cursor-wait aria-disabled:opacity-60 sm:min-h-8"
          onClick={onViewRequest}
          aria-disabled={isSelecting}
          aria-busy={isSelecting}
        >
          {copy.viewRequest}
        </Button>
      </div>
    </div>
  );
}
